import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';
import { map, filter } from 'rxjs/operators';
import { parseLocation } from '@webapp/utils/rudderstack/parseLocation';

export const PAGE_NAMES: { path: string; name: string }[] = [
  { path: '/register/verify', name: 'Registration Page (Verification Code)' },
  { path: '/register', name: 'Registration Page' },
  {
    path: '/login/forgot-password/verify',
    name: 'Change password (Verification Code)',
  },
  { path: '/login/forgot-password', name: 'Change password' },
  { path: '/login', name: 'Login Page' },
  { path: '/dashboard', name: 'Dashboard' },
  { path: '/earnings', name: 'Earnings' },
  { path: '/onboarding', name: 'Onboarding Section (Create Artist)' },
  { path: '/plans/:clientId?/:id?', name: 'Onboarding Section (Select Plan)' },
  { path: '/payment/:clientId?/:id?', name: 'Onboarding Section (Payment)' },
  { path: '/invite-team', name: 'Onboarding Section (Invite Team)' },
  { path: '/analytics/streaming', name: 'Analytics (Streaming)' },
  { path: '/analytics/microsite', name: 'Analytics (Microsite)' },
  { path: '/analytics', name: 'Analytics' },
  { path: '/user/general', name: 'User Profile (General)' },
  { path: '/user/banking', name: 'User Profile (Wallet)' },
  { path: '/label', name: 'Record Label' },
  { path: '/user/security', name: 'User Profile (Security)' },
  { path: '/artist/profile', name: 'Artist (Profile)' },
  { path: '/artist/team', name: 'Artist (Team)' },
  { path: '/artist/subscriptions', name: 'Artist (Subscriptions)' },
  { path: '/artist/subscriptions/invoices', name: 'Artist (Invoices)' },
  { path: '/artist/presets', name: 'Artist (Presets)' },
  { path: '/artist/earnings', name: 'Artist (Earnings)' },
  { path: '/artist/billing', name: 'Artist (Billing)' },
  { path: '/artist/new', name: 'Create new Artist' },
  { path: '/artist/page/:section', name: 'Artist Microsite Settings' },
  { path: '/release/title', name: 'New Release (Title Section)' },
  { path: '/release/details', name: 'New Release (Names + Genre Section)' },
  {
    path: '/release/:artistId?/:releaseId?/title',
    name: 'New Release (Title Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/details',
    name: 'New Release (Names + Genre Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/dates',
    name: 'New Release (Dates Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/track/:trackId',
    name: 'New Release (Track Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/preview',
    name: 'New Release (Preview Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/payment',
    name: 'New Release (Payment Section)',
  },
  {
    path: '/release/:artistId?/:releaseId?/published',
    name: 'New Release (Published Section)',
  },
  { path: '/release', name: 'New Release (Title Section)' },
  { path: '/music-video', name: 'New Music Video' },
  { path: '/terms-of-service', name: 'Terms Of Service' },
  { path: '/privacy-policy', name: 'Pricacy Policy' },
  { path: '/alpha-pilot-user-agreement', name: 'Alpha Pilot Users Agreement' },
  {
    path: '/user-profile/change-split/:assetType/:releaseId/:trackId/:songName/:type',
    name: 'Manage Ownership',
  },
];

const getName = (path: string): { path: string; name: string } | undefined => {
  const result = PAGE_NAMES.find((data) => {
    if (!data.path.includes(':')) {
      return path.replace(/\/$/, '') === data.path;
    }

    const rx = data.path.replace(/:[^/]+/g, '[^/]+');

    return new RegExp(`^${rx}$`).test(path);
  });

  return result;
};

export const trackLocationChangeEpic = (
  action$: Observable<LocationChangeAction>
) =>
  action$.pipe(
    ofType(LOCATION_CHANGE),
    map((action) => {
      const url = window.location.origin + window.location.pathname;
      const nameObj: { path: string; name?: string } = {
        ...getName(action.payload.location.pathname),
        path: url,
      };

      if (nameObj?.name) {
        parseLocation(nameObj);
      } else {
        parseLocation({ path: url });
      }
    }),
    filter(() => false)
  );
